var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogWrapper',{attrs:{"close-on-cancel":"","title":_vm.$t(`${_vm.i18nPrefix}.title.${_vm.i18nTitleKey}`),"show":_vm.show,"loading":_vm.loading},on:{"update:show":function($event){_vm.show=$event},"save":_vm.handleSave}},[_c('WrappedForm',{ref:"form",attrs:{"hideRequiredAsterisk":"","model":_vm.groupInfo,"formLines":_vm.formLines}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }